export default {
    name: 'Ime',
    tel: 'Telefon',
    save: 'Spremi',
    confirm: 'Potvrdi',
    cancel: 'Otkaži',
    delete: 'Izbriši',
    complete: 'Dovrši',
    loading: 'Učitavanje...',
    telEmpty: 'Molimo unesite telefon',
    nameEmpty: 'Molimo unesite ime',
    nameInvalid: 'Neispravno ime',
    confirmDelete: 'Jeste li sigurni da želite izbrisati?',
    telInvalid: 'Neispravan broj telefona',
    vanCalendar: {
        end: 'Kraj',
        start: 'Početak',
        title: 'Kalendar',
        startEnd: 'Početak/Kraj',
        weekdays: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Odaberite najviše ${maxRange} dana`,
    },
    vanCascader: {
        select: 'Odaberi',
    },
    vanContactCard: {
        addText: 'Dodaj kontakt informacije',
    },
    vanContactList: {
        addText: 'Dodaj novi kontakt',
    },
    vanPagination: {
        prev: 'Prethodno',
        next: 'Sljedeće',
    },
    vanPullRefresh: {
        pulling: 'Povucite za osvježavanje...',
        loosing: 'Otpustite za osvježavanje...',
    },
    vanSubmitBar: {
        label: 'Ukupno:',
    },
    vanCoupon: {
        unlimited: 'Neograničeno',
        discount: (discount) => `${discount * 10}% popusta`,
        condition: (condition) => `Najmanje ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupon',
        tips: 'Nema kupona',
        count: (count) => `Imate ${count} kupon${count !== 1 ? 'a' : ''}`,
    },
    vanCouponList: {
        empty: 'Nema kupona',
        exchange: 'Razmjena',
        close: 'Zatvori',
        enable: 'Dostupno',
        disabled: 'Nedostupno',
        placeholder: 'Kod kupona',
    },
    vanAddressEdit: {
        area: 'Područje',
        postal: 'Poštanski broj',
        areaEmpty: 'Molimo odaberite područje',
        addressEmpty: 'Adresa ne može biti prazna',
        postalEmpty: 'Neispravan poštanski broj',
        defaultAddress: 'Postavi kao zadanu adresu',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Ime',
        areaPlaceholder: 'Područje',
    },
    vanAddressEditDetail: {
        label: 'Adresa',
        placeholder: 'Adresa',
    },
    vanAddressList: {
        add: 'Dodaj novu adresu',
    },
};